import { emit } from '@zapier/events-toolkit-browser';

export const UserInteractionEvent =
  'web_analytics.tracking.user_interaction.UserInteractionEvent';

export type EventDetails = {
  interaction_name?: string;
  event_action: string;
  option_selected?: string;
  interaction_raw_text?: string;
  destination_href?: string;
  experiment_flag?: boolean;
  experiment_name?: string;
  custom_tracking_fields?: null | {
    [index: string]: null | undefined | string;
  };
};

export enum InteractionName {
  plan_usage_component_in_view = 'plan_usage_component_in_view',
  plan_usage_mouse_enter = 'plan_usage_mouse_enter',
  plan_usage_click = 'plan_usage_click',
}

export enum InteractionGoal {
  plan_usage = 'plan_usage',
}

export const emitUserInteractionEvent = async ({
  interaction_name = 'call_to_action',
  ...eventDetails
}: EventDetails) => {
  return await emit(
    {
      ...eventDetails,
      absolute_url: window.location.pathname,
      interaction_name,
      referrer: document.referrer,
      system_name: 'design_system',
    },
    UserInteractionEvent
  );
};

export const emitUserInteractionComponentInView = (
  interactionName: InteractionName,
  interactionGoal: InteractionGoal,
  systemName?: string
) => {
  return emit(
    {
      event_action: 'in_view',
      absolute_url: window.location.pathname,
      interaction_name: interactionName,
      interaction_goal: interactionGoal,
      system_name: systemName || 'design_system',
      // option_selected is a required property in avro schema, even if it is not applicable
      option_selected: 'not_applicable',
    },
    UserInteractionEvent
  );
};

export const emitUserInteractionClick = (
  interactionName: InteractionName,
  interactionGoal: InteractionGoal,
  text: string,
  destinationHref?: string,
  systemName?: string
) => {
  return emit(
    {
      event_action: 'click',
      system_name: systemName || 'design_system',
      interaction_name: interactionName,
      interaction_goal: interactionGoal,
      option_selected: text,
      interaction_raw_text: text,
      destination_href: destinationHref,
      absolute_url: window.location.pathname,
    },
    UserInteractionEvent
  );
};

export const emitUserInteractionHover = (
  interactionName: InteractionName,
  interactionGoal: InteractionGoal,
  systemName?: string
) => {
  return emit(
    {
      event_action: 'hover',
      system_name: systemName || 'design_system',
      interaction_name: interactionName,
      interaction_goal: interactionGoal,
      option_selected: 'not_applicable',
      absolute_url: window.location.pathname,
    },
    UserInteractionEvent
  );
};
